if (!customElements.get('faq-hero-search')) {
  customElements.define(
    'faq-hero-search',
    class FaqHeroSearch extends HTMLElement {
      constructor() {
        super();
        this.faqRoot = null;
        this.data = null;
        this.activeIndex = -1;
        this.lastResults = [];
      }

      connectedCallback() {
        this.input = this.querySelector('.DT_faqhero__search-input');
        this.clearBtn = this.querySelector('.DT_faqhero__search-clear');
        this.resultsEl = this.querySelector('.DT_faqhero__results');
        this.noResultsEl = this.querySelector('.DT_faqhero__no-results');
        if (!this.input) return;

        this.faqRoot = document.querySelector('.DT_faq');
        if (this.faqRoot) {
          var sid = this.faqRoot.getAttribute('data-section-id');
          var jsonEl = document.getElementById('DT_faq_data-' + sid);
          if (jsonEl) {
            try {
              this.data = JSON.parse(jsonEl.textContent);
            } catch (e) {
              console.error('FAQ Hero: failed to parse FAQ data JSON', e);
            }
          }
        }

        // Wire input
        this.input.addEventListener('input', this.handleInput.bind(this));
        this.input.addEventListener('focus', this.handleFocus.bind(this));
        this.input.addEventListener('blur', this.handleBlur.bind(this));
        this.input.addEventListener('keydown', this.handleKeydown.bind(this));

        if (this.clearBtn) {
          this.clearBtn.addEventListener('click', this.clearSearch.bind(this));
        }
      }

      handleInput() {
        this.updateClearButton();
        this.updateResults();
      }

      handleFocus() {
        if (this.input.value.length >= 2) this.updateResults();
      }

      handleBlur() {
        // Delay hide so clicks on results register first
        setTimeout(this.hideResults.bind(this), 200);
      }

      handleKeydown(e) {
        if (e.key === 'Escape') {
          this.clearSearch();
          this.input.blur();
          return;
        }
        if (!this.lastResults.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.moveSelection(1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.moveSelection(-1);
        } else if (e.key === 'Enter') {
          if (this.activeIndex >= 0 && this.lastResults[this.activeIndex]) {
            e.preventDefault();
            var sel = this.lastResults[this.activeIndex];
            this.onSelectItem(sel.entryId, sel.tab);
          }
        }
      }

      moveSelection(delta) {
        var n = this.lastResults.length;
        if (!n) return;
        this.activeIndex = (this.activeIndex + delta + n) % n;
        this.syncSelection();
      }

      syncSelection() {
        if (!this.resultsEl) return;
        var items = this.resultsEl.querySelectorAll('.DT_faqhero__result');
        items.forEach(function (el, i) {
          el.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false');
          if (i === this.activeIndex) {
            el.scrollIntoView({ block: 'nearest' });
          }
        }, this);
      }

      updateClearButton() {
        if (!this.clearBtn) return;
        if (this.input.value) this.clearBtn.removeAttribute('hidden');
        else this.clearBtn.setAttribute('hidden', '');
      }

      updateResults() {
        if (!this.resultsEl || !this.data || !this.data.items) {
          this.hideResults();
          return;
        }
        var q = this.input.value.trim().toLowerCase();
        if (q.length < 2) {
          this.hideResults();
          return;
        }
        var matches = this.data.items.filter(function (it) {
          return (
            (it.question && it.question.toLowerCase().indexOf(q) !== -1) ||
            (it.answer_text && it.answer_text.toLowerCase().indexOf(q) !== -1)
          );
        }).slice(0, 8);

        this.lastResults = matches;
        this.activeIndex = -1;

        if (!matches.length) {
          this.resultsEl.setAttribute('hidden', '');
          this.resultsEl.innerHTML = '';
          if (this.noResultsEl) this.noResultsEl.removeAttribute('hidden');
          return;
        }
        if (this.noResultsEl) this.noResultsEl.setAttribute('hidden', '');

        var tabsByN = {};
        if (this.data.tabs) {
          this.data.tabs.forEach(function (t) { tabsByN[t.n] = t.label; });
        }

        var self = this;
        this.resultsEl.innerHTML = matches.map(function (it, i) {
          var tabLabel = tabsByN[it.tab] || '';
          var ans = self.truncate(it.answer_text || '', 140);
          return (
            '<li class="DT_faqhero__result" role="option" aria-selected="false" data-index="' + i + '">' +
              (tabLabel ? '<div class="DT_faqhero__result-tab">' + self.escapeHtml(tabLabel) + '</div>' : '') +
              '<div class="DT_faqhero__result-question">' + self.highlight(it.question || '', q) + '</div>' +
              (ans ? '<div class="DT_faqhero__result-answer">' + self.highlight(ans, q) + '</div>' : '') +
            '</li>'
          );
        }).join('');

        // Wire result clicks (mousedown so it fires before blur hides results)
        this.resultsEl.querySelectorAll('.DT_faqhero__result').forEach(function (el) {
          el.addEventListener('mousedown', function (e) {
            e.preventDefault();
            var idx = parseInt(el.getAttribute('data-index'), 10);
            var sel = self.lastResults[idx];
            if (sel) self.onSelectItem(sel.entryId, sel.tab);
          });
        });

        this.resultsEl.removeAttribute('hidden');
      }

      hideResults() {
        if (this.resultsEl) this.resultsEl.setAttribute('hidden', '');
        if (this.noResultsEl) this.noResultsEl.setAttribute('hidden', '');
        this.activeIndex = -1;
        this.lastResults = [];
      }

      clearSearch() {
        if (this.input) this.input.value = '';
        this.updateClearButton();
        this.hideResults();
        if (this.input) this.input.focus();
      }

      onSelectItem(entryId, tab) {
        if (!this.faqRoot) return;

        // 1. Switch tab on desktop (the existing FAQ JS handles state).
        var tabBtn = this.faqRoot.querySelector('.DT_faq__tab[data-faq-tab="' + tab + '"]');
        if (tabBtn) tabBtn.click();

        // 2. Expand the mobile group card for this tab (if collapsed).
        var group = this.faqRoot.querySelector('.DT_faq__group[data-faq-tab="' + tab + '"]');
        if (group && group.getAttribute('data-open') !== 'true') {
          var groupSummary = group.querySelector('.DT_faq__group-summary');
          if (groupSummary) groupSummary.click();
        }

        // 3. Open the matched item.
        var item = this.faqRoot.querySelector('.DT_faq__item[data-entry-id="' + entryId + '"]');
        if (item) item.setAttribute('open', '');

        // 4. Scroll to it (with sticky-header offset).
        if (item) {
          var self = this;
          // Wait a tick so any tab-switch reflow lands first.
          setTimeout(function () {
            var y = item.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: y, behavior: 'smooth' });
            self.clearSearch();
          }, 50);
        } else {
          this.clearSearch();
        }
      }

      truncate(text, n) {
        if (!text) return '';
        return text.length > n ? text.slice(0, n) + '…' : text;
      }

      escapeHtml(s) {
        return String(s)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      escapeRegex(s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      highlight(text, q) {
        var safe = this.escapeHtml(text);
        if (!q) return safe;
        var re = new RegExp('(' + this.escapeRegex(q) + ')', 'gi');
        return safe.replace(re, '<mark>$1</mark>');
      }
    }
  );
}
